/**
 * Query Keys for Settings Context
 *
 * Centralized query keys for TanStack Query cache management.
 * Following the pattern from ScheduledMeetingsContext.
 */

export const SETTINGS_QUERY_KEYS = {
  /**
   * Key for profile settings cache
   */
  settings: ['profile-settings'] as const,

  /**
   * Key for TOS acceptance cache
   */
  tos: ['tos-acceptance'] as const,

  /**
   * Key for TOS metadata cache (modified date)
   */
  tosMetadata: ['tos-metadata'] as const,
} as const;
